import { Component, OnInit } from '@angular/core';
import { SvNotificationStatus } from 'sv-chemistry-ng-lib';
import { PageLevelNotificationService, SvNotification } from '../../services/page-level-notification.service';

@Component({
  selector: 'sv-page-notification-output',
  templateUrl: './sv-page-notification-output.component.html',
  styleUrls: ['./sv-page-notification-output.component.scss']
})
export class SvPageNotificationOutputComponent implements OnInit {
  showPageNotification: boolean = false;
  message: string = "";
  messageType: SvNotificationStatus = SvNotificationStatus.None;
  
  constructor(private _pageNotificationService: PageLevelNotificationService) { 
  }

  ngOnInit() {
    this._pageNotificationService.opened.subscribe((notification: SvNotification) => {
      this.showPageNotification = true;
      this.message = notification.message;
      this.messageType = notification.type;
    })
    this._pageNotificationService.closed.subscribe((isClosed: boolean) => {
      this.showPageNotification = false;
    })
  }}
